import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface ICustomTab {
  label: string;
  index: number;
  handleChangeTab: (index: number) => void;
}

export default function CustomTab({
  label,
  index,
  handleChangeTab,
  ...rest
}: ICustomTab) {
  return (
    <Button
      onClick={() => handleChangeTab(index)}
      sx={{
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "3px",
        paddingBottom: "10px",
        paddingTop: "10px",
        // border: "1px solid gray",
        minWidth: "fit-content",
        // textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          color: "primary.main",
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          flexShrink: 0,
          width: "18px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // border: "1px solid gray",
          borderRadius: "50%",
          backgroundColor: "primary.main",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "12px",
            color: "background.default",
          }}
        >
          15
        </Typography>
      </Box>
    </Button>
  );
}
